// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"ed59a23d","832":"be65a3ee"}[chunkId] + ".chunk.js";
};